import script from "./StatisticsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsComponent.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsComponent.vue?vue&type=style&index=0&id=eabde8ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eabde8ca"]])

export default __exports__